import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";

import { PageSpinner } from "@/components/ui/Spinner";
import { useSession } from "@/context/SessionContext";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { signedIn, loading } = useSession();
  const location = useLocation();

  if (loading) return <PageSpinner />;
  if (!signedIn) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate replace to={`/login?next=${next}`} />;
  }
  return <>{children}</>;
}
